import styled from "styled-components";
import { MenuOutlined } from "@ant-design/icons";

export const Toggle = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;

  &:hover {
    cursor: pointer;
  }
`;

export const MenuIcon = styled(MenuOutlined)`
  color: #000;
  font-size: 24px;
  transform: ${props => props.isMenuOpen ? 'rotate(90deg)' : 'none'};
  transition: transform 0.3s;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
`;

export const VersionText = styled.span`
  margin: 2px 0 4px 6px;
  color: #7c7c7c;
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
`;

